/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileReportData } from '../../models/profile-report-data';

export interface ProfileReportSummaryData$Params {

/**
 * ID of profile
 */
  id: number;
  from: number;
  to: number;
}

export function profileReportSummaryData(http: HttpClient, rootUrl: string, params: ProfileReportSummaryData$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileReportData>> {
  const rb = new RequestBuilder(rootUrl, profileReportSummaryData.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('from', params.from, {});
    rb.path('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileReportData>;
    })
  );
}

profileReportSummaryData.PATH = '/rest/profile/{id}/report/summary/{from}/{to}';
